import { categoriesMock, buildProductsSearchMockResponse } from "./productsSearchMock";

function makeCatalogImport({ index, startDateIso }) {
  const jobId = `job-${index + 1}`;

  // Stato precedente: numeri vari e talvolta senza errori
  const previousTotaleRecord = 50 + (index % 7) * 25; // 50, 75, 100, ...
  const previousTotaleErrori =
    index % 4 === 0 ? 0 : ((index % 5) + (index % 3)) % 6; // mix di 0 e valori 1-5

  // Esecuzione attuale: leggero incremento/decremento, con errori variabili
  const delta = (index % 5) - 2; // -2 .. +2
  const totaleRecord = Math.max(10, previousTotaleRecord + delta * 5);
  const totaleErrori =
    index % 3 === 0 ? 0 : ((index * 2) % 7); // mix 0..6 con alcuni zeri

  return {
    jobId,
    totaleRecord,
    totaleErrori,
    previousTotaleRecord,
    previousTotaleErrori,
    startTime: startDateIso,
  };
}

const MOCK_IMPORT_TOTAL = 45;

export function buildGetCatalogsMockResponse({ limit, offset }) {
  const safeLimit = typeof limit === "number" && limit > 0 ? limit : 20;
  const safeOffset = typeof offset === "number" && offset >= 0 ? offset : 0;
  const remaining = Math.max(0, MOCK_IMPORT_TOTAL - safeOffset);
  const pageSize = Math.min(safeLimit, remaining);

  const now = new Date();
  const imports = Array.from({ length: pageSize }).map((_, i) =>
    makeCatalogImport({
      index: safeOffset + i,
      startDateIso: new Date(now.getTime() - (safeOffset + i) * 3600 * 1000).toISOString(),
    })
  );

  return {
    imports,
    totalCount: MOCK_IMPORT_TOTAL,
  };
}

export function buildGetCatalogImportDetailsMockResponse({ limit, page }) {
  const safeLimit = typeof limit === "number" ? limit : 9;
  const safePage = typeof page === "number" ? page : 0;

  const startIndex = safePage * safeLimit;
  const errors = Array.from({ length: safeLimit }).map((_, i) => ({
    rowIndex: startIndex + i + 1,
    colonneErrori: `errore_colonna_${(startIndex + i + 1).toString()}`,
    issueType: i % 3 === 0 ? "warning" : "error",
  }));

  return {
    statistics: {
      totalProducts: 6248,
      productsImported: 120,
      unchangedProducts: 6128,
      productsWithErrors: safeLimit,
      productsWithWarnings: 3,
      newProducts: 45,
      deactivatedProducts: 2,
      undeactivatedProducts: 1,
      deletedProducts: 0,
      undeletedProducts: 0,
      globalErrors: [],
      globalWarnings: [],
    },
    errors,
    totalCount: 50,
  };
}

export function buildImportCsvMockResponse() {
  return {
    message: "Upload completato con successo",
  };
}

export function buildModifyCatalogMockResponse() {
  return {
    statusCode: 202,
    message: "Modifica completata (mock)",
  };
}

export function buildDeleteCatalogMockResponse() {
  return {
    statusCode: 202,
    message: "Eliminazione completata (mock)",
  };
}

// Optional: if some page wants products response from catalog mock.
export function buildCatalogProductsFallbackMock({ limit, page, vendorId, ordine, ricerca }) {
  return buildProductsSearchMockResponse({ limit, page, vendorId, ordine, ricerca, categorie: categoriesMock });
}

